export default __webpack_public_path__ + "static/media/hoppia_events_black.e4d5a76b.svg";